// src/components/product-type.ts
var ProductType = /* @__PURE__ */ function(ProductType2) {
    ProductType2["GroundTransportation"] = "GroundTransportation";
    ProductType2["Lodging"] = "Lodging";
    ProductType2["Cruise"] = "Cruise";
    return ProductType2;
}(ProductType || {});
// src/components/product-type-context.ts
import { createContext } from "react";
var ProductTypeContext = createContext(null);
// src/components/product-type-provider.tsx
import React from "react";
var Provider = ProductTypeContext.Provider;
var ProductTypeProvider = function(param) {
    var productType = param.productType, children = param.children;
    return /* @__PURE__ */ React.createElement(Provider, {
        value: productType
    }, children);
};
// src/components/use-product-type.ts
import { useContext } from "react";
var useProductType = function() {
    return useContext(ProductTypeContext);
};
export { ProductType, ProductTypeContext, ProductTypeProvider, useProductType };
//# sourceMappingURL=index.js.map